// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../generated-types'

import gql from 'graphql-tag'
export type EventHeaderFragment = {
  __typename?: 'Enquiry'
  title: string
  audience: Types.Audience
  collection: { __typename?: 'Collection'; label: string }
}

export const EventHeaderFragmentDoc = gql`
  fragment EventHeader on Enquiry {
    title
    audience
    collection {
      label
    }
  }
`
